module.exports = "<h1>Stats Page</h1>\r\n<div *ngFor=\"let item of userStatsData | keyvalue\">\r\n    {{item.key}}:{{item.value}}\r\n  </div>"